import React from 'react';

import { FormControlLabel, SwitchProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import AppSwitch from '../app-switch/AppSwitch';
import { useStyles } from './AppSwitchWithLabel.styles';

interface AppSwitchWithLabelProps extends SwitchProps {
  label: React.ReactNode;
  labelClassName?: string;
  labelPlacement?: 'top' | 'start' | 'bottom' | 'end';
  fullWidth?: boolean;
  value: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function AppSwitchWithLabel(props: AppSwitchWithLabelProps) {
  const {
    label,
    labelClassName,
    labelPlacement = 'start',
    className,
    fullWidth,
    ...switchProps
  } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <FormControlLabel
      control={<AppSwitch className={className} {...switchProps} />}
      className={clsx(
        classes.switchControlLabel,
        fullWidth && classes.switchControlLabelFullWidth,
        labelClassName,
      )}
      labelPlacement={labelPlacement}
      label={label}
      style={{
        display: label ? 'inline-flex' : 'block',
      }}
    />
  );
}
